import { makeEpisodeRoutes } from "@/routes/episodeRoutes"

export default makeEpisodeRoutes({
  listName: "station.podcasts.episodes",
  createName: "station.episodes.create",
  detailName: "station.podcasts.episode",
  editName: "station.podcasts.episode.edit",
  parent: "stations",
})
